export const SEO = ({ title, slug, excerpt }) => {
  const full_title = `Warren Carter &bull; ${title}`;

  const metatags = [
    { "type": "name", "category": "description", "value": excerpt },
    { "type": "property", "category": "og:description", "value": excerpt },
    { "type": "name", "category": "twitter:description", "value": excerpt },
    { "type": "name", "category": "twitter:title", "value": full_title },
    { "type": "name", "category": "og:title", "value": full_title },
    { "type": "name", "category": "og:url", "value": full_title }
  ]

  setTitle(full_title);
  setMetaTag(metatags);
  setLinks(slug);
}

const setTitle = (full_title) => {
  document.title = full_title;
}

const setMetaTag = (metatags) => {
  for (let tag of metatags) {
    const el = document.querySelector(`meta[${tag.type}="${tag.category}"]`);

    if (el) {
      el.setAttribute("content", tag.value);
    } else {
      const link = document.createElement('meta');
      link.setAttribute(`${tag.type}`, `${tag.category}`)
      link.content = tag.value
      document.head.append(link);
    }
  }
}

const setLinks = (slug) => {
  const el = document.querySelector('link[rel="canonical"]');

  if (el) {
    el.setAttribute("href", `https://wtomcarter.uk/${slug}`);
  } else {
    const link = document.createElement('link');
    link.rel = 'canonical'
    link.setAttribute(`href`, `https://wtomcarter.uk/${slug}`)
    document.head.append(link);
  }
}